import React from 'react'
import { Filter, List, TextInput } from 'react-admin'
import { CustomSearchFilter, HistoryDatagrid } from '~/components'

const HistoryFilter = (props: object) => (
  <Filter {...props}>
    <TextInput label='pos.search' source='relation' alwaysOn />
  </Filter>
)

const HistoryList = (props: object) => {
  const searchColums = ['relation', 'operation']
  return (
    <List
      label='resources.name'
      filters={<CustomSearchFilter {...props} columns={searchColums} />}
      bulkActionButtons={false}
      {...props}
      sort={{ field: 'time', order: 'DESC' }}
    >
      <HistoryDatagrid />
    </List>
  )
}

export default HistoryList
